import React from "react";
import { HomePage } from "./pages";
export default function App() {
  return (
    <>
      <HomePage />
    </>
  );
}
